module.exports = __webpack_public_path__ + "static/media/play.b6d395d9.svg";